import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";



export interface IUploadCheckCardBinFileRequest {
  files: File[];
}

async function uploadCheckedCardBinFile(formData: FormData): Promise<any> {
  try {
    return (await axiosInstance.post("/CardBin/UploadCheckedBinListFromExcel", formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useAddCheckedCardBinFile() {
  return useMutation<any, Error, FormData>(
    (variables) => uploadCheckedCardBinFile(variables)
  );
}